export const checklistItemTypes = [
  'Management',
  'Restaurant',
  'Kitchen',
  'Market',
  'Hesburger',
  'Dishes',
  'CleanupPlan',
  'SelfObservation',
  'Night',
]

export const checklistItemDays = [
  'Everyday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
]
